import { render, staticRenderFns } from "./Lorton.vue?vue&type=template&id=71379b53&scoped=true&"
import script from "./Lorton.vue?vue&type=script&lang=js&"
export * from "./Lorton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71379b53",
  null
  
)

export default component.exports